// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-practice-view-attempts {
  background: #ff6636 !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: left;
  margin-bottom: 15px;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.submit-question-button {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: left;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.eliminated-option {
  color: #aaa !important;
  background-color: #f0f0f0 !important;
}
.eliminated-option::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #000;
  transform: translateY(-50%);
}

.student-practice-view-attempts:hover {
  background-color: #f97e59 !important;
}

.student-practice-view-attempts:active {
  transform: translateY(0.5px);
}

.student-practice-view-attempts:focus {
  outline: none;
}

.end-practice-styles {
  font-family: Plus Jakarta Sans;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: left !important;
  padding: 0px 16px 0px 16px !important;
  color: #ff6636 !important;
  background-color: #ffeee8 !important;
  border-color: #ffeee8 !important;
}

.end-practice-styles:hover {
  color: white !important;
  background-color: #ff6636 !important;
}

.no-border {
  border: 0px !important;
}

.option-hover:hover {
  border: 1px solid #ff6636 !important;
}

.display-options textarea {
  height: 76px !important;
  border-radius: 10px;
}

.error-border {
  border: 1px solid red !important;
}

.success-border {
  border: 1px solid #23bd33 !important;
}

.accordion-attempts-result button {
  padding-right: 24px !important;
}

.attempt-performance-results canvas {
  height: 100px !important;
  width: 100px !important;
}

.view-solution-classroom-styles {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: left;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.link-button-classroom-styles {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  text-align: left !important;
  padding: 0px 16px 0px 16px !important;
  color: #564ffd !important;
}

.link-button-classroom-styles:hover {
  color: #312e8c !important;
}

.attempt-handler-button-styles {
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 48px !important;
  letter-spacing: -0.004em;
  text-align: left;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.practice-set-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: background-color 0.2s;
  min-height: 80px;
}
.practice-set-item:hover {
  background-color: #e9ecef;
}

.practice-set-info {
  flex: 1 1;
  min-width: 0;
}
.practice-set-info h6 {
  margin: 0;
  color: #212529;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.practice-set-info .score-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 0.25rem;
  font-size: 0.875rem;
  color: #6c757d;
}
.practice-set-info .score-info .score-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #e9ecef;
  font-size: 0.75rem;
  font-weight: 500;
  color: #495057;
  min-width: 80px;
  justify-content: center;
}
.practice-set-info .score-info .score-badge::before {
  margin-right: 4px;
}
.practice-set-info .score-info .score-badge.mastered {
  background-color: #d1fae5;
  color: #065f46;
}
.practice-set-info .score-info .score-badge.in-progress {
  background-color: #fef3c7;
  color: #92400e;
}
.practice-set-info .score-info .score-badge.not-started {
  background-color: #f3f4f6;
  color: #6b7280;
}

.topic-mastery-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-left: 8px;
  vertical-align: middle;
  min-width: 100px;
  justify-content: center;
}
.topic-mastery-badge.mastered {
  background-color: #d1fae5;
  color: #065f46;
}
.topic-mastery-badge.in-progress {
  background-color: #fef3c7;
  color: #92400e;
}
.topic-mastery-badge.not-started {
  background-color: #f3f4f6;
  color: #6b7280;
}

.practice-question-container img {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

.practice-content img {
  max-width: 100% !important;
  height: auto !important;
}

.no-hidden-overflow {
  overflow: visible !important;
}

.statement-container,
.statement-multiline {
  overflow: hidden;
  word-wrap: break-word;
}
.statement-container img,
.statement-multiline img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}
.statement-container span img,
.statement-multiline span img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

img[width],
img[height] {
  max-width: 100% !important;
  height: auto !important;
  width: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentPages/Practice/styles.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AACF;;AAEA;EACI,sBAAA;EACA,oCAAA;AACJ;AAAI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAEN;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;AACF;;AAEA;EACE,uBAAA;EACA,oCAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAGE;EACE,uBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,gCAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAKE;EACE,wBAAA;EACA,uBAAA;AAFJ;;AAMA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,yBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,2BAAA;EACA,8BAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;AAHF;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,SAAA;EACA,YAAA;AAJF;AAME;EACE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AALJ;AAOI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AALN;AAOM;EACE,iBAAA;AALR;AAQM;EACE,yBAAA;EACA,cAAA;AANR;AASM;EACE,yBAAA;EACA,cAAA;AAPR;AAUM;EACE,yBAAA;EACA,cAAA;AARR;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;AAXF;AAaE;EACE,yBAAA;EACA,cAAA;AAXJ;AAcE;EACE,yBAAA;EACA,cAAA;AAZJ;AAeE;EACE,yBAAA;EACA,cAAA;AAbJ;;AAmBE;EACE,0BAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAhBJ;;AAsBE;EACE,0BAAA;EACA,uBAAA;AAnBJ;;AAuBA;EACE,4BAAA;AApBF;;AAwBA;;EAWE,gBAAA;EACA,qBAAA;AA9BF;AAoBE;;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAjBJ;AA0BI;;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAvBN;;AA6BA;;EAEE,0BAAA;EACA,uBAAA;EACA,sBAAA;AA1BF","sourcesContent":[".student-practice-view-attempts {\n  background: #ff6636 !important;\n  color: white !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: left;\n  margin-bottom: 15px;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.submit-question-button {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: left;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.eliminated-option {\n    color: #aaa !important; // Grey out the text to make it look disabled\n    background-color: #f0f0f0 !important; // Optionally change the background to indicate it's disabled\n    &::after {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 0; // Extend the line 3px beyond the left side\n      right: 0; // Extend the line 3px beyond the right side\n      height: 1px; // Line thickness\n      background: #000; // Line color\n      transform: translateY(-50%); // Center the line vertically\n    }\n  }\n\n.student-practice-view-attempts:hover {\n  background-color: #f97e59 !important;\n}\n\n.student-practice-view-attempts:active {\n  transform: translateY(0.5px);\n}\n\n.student-practice-view-attempts:focus {\n  outline: none;\n}\n\n.end-practice-styles {\n  font-family: Plus Jakarta Sans;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: left !important;\n  padding: 0px 16px 0px 16px !important;\n  color: #ff6636 !important;\n  background-color: #ffeee8 !important;\n  border-color: #ffeee8 !important;\n}\n\n.end-practice-styles:hover {\n  color: white !important;\n  background-color: #ff6636 !important;\n}\n\n.no-border {\n  border: 0px !important;\n}\n\n.option-hover:hover {\n  border: 1px solid #ff6636 !important;\n}\n\n.display-options {\n  textarea {\n    height: 76px !important;\n    border-radius: 10px;\n  }\n}\n\n.error-border {\n  border: 1px solid red !important;\n}\n\n.success-border {\n  border: 1px solid #23bd33 !important;\n}\n\n.accordion-attempts-result button {\n  padding-right: 24px !important;\n}\n\n.attempt-performance-results {\n  canvas {\n    height: 100px !important;\n    width: 100px !important;\n  }\n}\n\n.view-solution-classroom-styles {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: left;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.link-button-classroom-styles {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  text-align: left !important;\n  padding: 0px 16px 0px 16px !important;\n  color: #564ffd !important;\n}\n\n.link-button-classroom-styles:hover {\n  color: #312e8c !important;\n}\n\n.attempt-handler-button-styles {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 48px !important;\n  letter-spacing: -0.004em;\n  text-align: left;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.practice-set-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n  min-height: 80px;\n\n  &:hover {\n    background-color: #e9ecef;\n  }\n}\n\n.practice-set-info {\n  flex: 1;\n  min-width: 0;\n\n  h6 {\n    margin: 0;\n    color: #212529;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .score-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 0.25rem;\n    font-size: 0.875rem;\n    color: #6c757d;\n\n    .score-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      padding: 2px 8px;\n      border-radius: 12px;\n      background-color: #e9ecef;\n      font-size: 0.75rem;\n      font-weight: 500;\n      color: #495057;\n      min-width: 80px;\n      justify-content: center;\n\n      &::before {\n        margin-right: 4px;\n      }\n\n      &.mastered {\n        background-color: #d1fae5;\n        color: #065f46;\n      }\n\n      &.in-progress {\n        background-color: #fef3c7;\n        color: #92400e;\n      }\n\n      &.not-started {\n        background-color: #f3f4f6;\n        color: #6b7280;\n      }\n    }\n  }\n}\n\n.topic-mastery-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-left: 8px;\n  vertical-align: middle;\n  min-width: 100px;\n  justify-content: center;\n\n  &.mastered {\n    background-color: #d1fae5;\n    color: #065f46;\n  }\n\n  &.in-progress {\n    background-color: #fef3c7;\n    color: #92400e;\n  }\n\n  &.not-started {\n    background-color: #f3f4f6;\n    color: #6b7280;\n  }\n}\n\n// Fix for image overflow in question containers\n.practice-question-container {\n  img {\n    max-width: 100% !important;\n    height: auto !important;\n    display: block;\n    margin: 0 auto;\n  }\n}\n\n// General fix for all images in practice area\n.practice-content {\n  img {\n    max-width: 100% !important;\n    height: auto !important;\n  }\n}\n\n.no-hidden-overflow {\n  overflow: visible !important;\n}\n\n// Specific fix for statement container images with inline width attributes\n.statement-container,\n.statement-multiline {\n  img {\n    max-width: 100% !important;\n    width: auto !important;\n    height: auto !important;\n    display: block;\n    margin: 0 auto;\n  }\n\n  // Ensure the container itself doesn't overflow\n  overflow: hidden;\n  word-wrap: break-word;\n\n  // Fix for content that might be rendered as spans\n  span {\n    img {\n      max-width: 100% !important;\n      width: auto !important;\n      height: auto !important;\n      display: block;\n      margin: 0 auto;\n    }\n  }\n}\n\n// Global fix for any image that might have inline width/height attributes\nimg[width],\nimg[height] {\n  max-width: 100% !important;\n  height: auto !important;\n  width: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
